import { Field, Formik, Form } from "formik";
import { useState } from "react";

import ReviewList, { sortByLatest } from "shared/components/ReviewList";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { getMostRecentQAReview } from "components/admin/adminUtils";
import { PathologyWatchButton } from "components/customInputs/buttons/Button";
import TextareaInput from "components/customInputs/TextareaInput";
import { useAppSelector } from "store/hooks";

import { QAReviewsProps } from "./qaReviewPanel";

const QAReviewForm = ({
  canReviewHold,
  qaReviews,
  caseId,
  onClose,
  onSubmit,
}: QAReviewsProps) => {
  const billingEntry = useAppSelector((state) =>
    selectFeatureFlag(state, "billingEntry")
  );
  const currentUser = useAppSelector(({ auth }) => auth.user);
  const mostRecentReview = getMostRecentQAReview(qaReviews);
  const reviewsOnly = qaReviews?.filter((review) => review.reviewed !== null);
  const [disabled, setDisabled] = useState(false);

  const handleOnSubmit = (values: any, reviewed: boolean | null) => {
    if (disabled) return;

    const payload = {
      caseId: caseId,
      note: values.note,
      reviewed,
      onClose,
    };

    setDisabled(true);
    onSubmit(payload);
  };

  const reviewList = sortByLatest(qaReviews);

  return (
    <Formik
      initialValues={{ note: "" }}
      enableReinitialize
      onSubmit={(values) => handleOnSubmit(values, true)}
    >
      {({ values }) => (
        <Form className="AdminPanelForm">
          <div className="panelContainer">
            <fieldset
              className="panelContainer__section panelContainer__section--stretch"
              style={{ gap: "0.2em" }}
            >
              <legend className="panelContainer__section--title">
                QA Review Logs
              </legend>
              <ReviewList reviews={reviewList} />
            </fieldset>
            <Field name="note">
              {({ field }: any) => (
                <TextareaInput label="Note" rows={4} {...field} />
              )}
            </Field>
          </div>
          <footer>
            <PathologyWatchButton onClick={() => onClose()}>
              Cancel
            </PathologyWatchButton>
            <div className="panelContainer__inputGroup">
              <PathologyWatchButton
                onClick={() => handleOnSubmit(values, null)}
                color="grey"
                disabled={!values.note}
              >
                Add Note
              </PathologyWatchButton>
              {(!reviewsOnly?.length || mostRecentReview?.reviewed) &&
                canReviewHold &&
                (!billingEntry || currentUser?.is_superuser) && (
                  <PathologyWatchButton
                    onClick={() => handleOnSubmit(values, false)}
                    color="red"
                  >
                    Hold Case
                  </PathologyWatchButton>
                )}
              {!mostRecentReview?.reviewed && canReviewHold && (
                <PathologyWatchButton color="green" type="submit">
                  Add QA Review
                </PathologyWatchButton>
              )}
            </div>
          </footer>
        </Form>
      )}
    </Formik>
  );
};

export default QAReviewForm;
